export default [
    {
      reducerKey: 'partners-program',
      sagaKey: 'partnersSaga',
      importReducer: () => import(/* webpackChunkName: "domain-partners" */ 'modules/PartnersProgram/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-partners" */ 'modules/PartnersProgram/store/saga'),
    },
]
